import PropTypes from "prop-types"
import React, { useEffect } from "react"
import { connect, useDispatch } from "react-redux"
import withRouter from "../../components/Common/withRouter"

import { logoutUser } from "../../store/actions"
import { useNavigate } from "react-router-dom"
import { setLogout } from "store/slices/authSlice"
import { get } from "../../api/axios"

const Logout = () => {
  document.title = " Logout | Dock Tok"

  const history = useNavigate()
  const dispatch = useDispatch()
  // const dispatch = null
  const logutHandler = async () => {
    const resp = await get(`/logout`)
    if (resp?.data?.success) {
      dispatch(setLogout())
      history("/login")
      localStorage.removeItem("accessToken")
    } else {
      dispatch(setLogout())
      history("/login")
      localStorage.removeItem("accessToken")
    }
  }
  useEffect(() => {
    // dispatch(logoutUser(history))
    logutHandler()
  }, [dispatch, history])

  return <></>
}

Logout.propTypes = {
  history: PropTypes.object,
  logoutUser: PropTypes.func,
}

// export default withRouter(connect(null, { logoutUser })(Logout))
export default withRouter(Logout)
